import React from 'react';
import whiteLogo from '@bbkAdminImages/growth-logo-white.png';
import logo from '@bbkAdminImages/growth-logo.png';
import { cs, type Argument } from '@bbkAdminUtils/css-utils';
import { type ReactFCC } from '@bbkAdminUtils/utility-types';

export const CBRetentionLogo: ReactFCC<{
  white?: boolean;
  className?: Argument;
}> = ({ white, className }) => (
  <img
    srcSet={`${white ? whiteLogo : logo} 2x`}
    className={cs(className ?? 'tw-w-full')}
    alt="Chargebee Growth"
  />
);
